export const wordByCount = ({ count, words }: { count: number; words: [string, string, string] }) => {
    const lastNumber = Number(String(count).slice(-1));
    if (lastNumber === 1) {
        return `${count} ${words[0]}`;
    }
    if (lastNumber >= 2 && lastNumber <= 4) {
        return `${count} ${words[1]}`;
    }
    return `${count} ${words[2]}`;
};
